import { Controller } from "@hotwired/stimulus"

// inline 편집 폼 토글 — 같은 화면 안에서 read-only ↔ 편집 모드 전환.
// 사용법:
//   <div data-controller="inline-edit">
//     <a data-action="click->inline-edit#toggle">수정</a>
//     <div data-inline-edit-target="form" class="hidden">...폼...</div>
//   </div>
export default class extends Controller {
  static targets = ["form"]

  toggle(event) {
    if (event) event.preventDefault()
    this.formTarget.classList.toggle("hidden")
    if (!this.formTarget.classList.contains("hidden")) {
      this.formTarget.scrollIntoView({ behavior: "smooth", block: "start" })
      const first = this.formTarget.querySelector("input, select, textarea")
      if (first) first.focus()
    }
  }

  hide() {
    this.formTarget.classList.add("hidden")
  }
}
